<template>
  <b-modal
    id="details"
    no-enforce-focus
    title="Informações do Usuario e do Produto"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
    @shown="openModal"
  >
    <div v-if="loading" class="grid-web">
      <b-tabs content-class="mt-3">
        <div v-if="type === 'REQUESTED'" class="actions-modal">
          <b-button
            variant="success"
            @click="accept(dataUser.id, dataUser.format)"
          >
            <i class="fas fa-check"></i>
          </b-button>
          <b-button
            variant="danger"
            @click="deny(dataUser.id, dataUser.format)"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </div>
        <b-tab title="Produto" active>
          <div class="grid-tab">
            <span>
              <b-form-group
                v-if="dataUser.images || dataUser.images.length"
                label="Imagem do Produto"
              >
                <b-carousel
                  id="carousel-fade"
                  style="border-radius: 3px"
                  fade
                  controls
                  img-width="1024"
                  img-height="480"
                >
                  <b-carousel-slide
                    v-for="image in dataUser.images"
                    :key="image.id"
                    class="image-size"
                    :img-src="image.path"
                  ></b-carousel-slide>
                </b-carousel>
              </b-form-group>
              <b-form-group v-else label="Imagem do Produto">
                <p class="ml-2">Sem Imagem</p>
              </b-form-group>
              <b-form-group label="ID do Produto">
                <b-form-input v-model="dataUser.id" disabled></b-form-input>
              </b-form-group>
              <b-form-group v-if="dataUser.format" label="Formato do Produto">
                <b-form-input
                  :value="formatProduct(dataUser.format)"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Nome do Produto">
                <b-form-input v-model="dataUser.name" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="Valor do Produto">
                <b-form-input
                  :value="'R$ ' + formatMoney(dataUser.amount)"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Categoria do Produto">
                <b-form-select
                  v-model="dataUser.category_id"
                  :options="categories"
                  disabled
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Tipo do Produto">
                <b-form-input
                  :value="typeFilter(dataUser.type)"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Descrição do Produto">
                <b-form-textarea
                  :value="dataUser.description"
                  disabled
                ></b-form-textarea>
              </b-form-group>
              <b-form-group label="Página de vendas">
                <b-form-input
                  v-if="dataUser.links && dataUser.links.length"
                  :value="dataUser.links[0].url || 'Sem link da página de vendas'"
                  disabled
                ></b-form-input>
              </b-form-group>
            </span>
            <span>
              <b-form-group label="Integrações do Produto">
                <div
                  v-if="details.attachment || details.attachment.length"
                  class="ml-2"
                >
                  <b-form-group label="Arquivos">
                    <div
                      v-for="attachments in details.attachment"
                      :key="attachments.id"
                      class="mb-2 ml-2"
                    >
                      <b-form-group label="">
                        <div class="grid-archive">
                          <b-form-input
                            :value="attachments.name"
                            disabled
                          ></b-form-input>
                          <div
                            v-if="canDownloadAttachment"
                            class="btnDownload"
                            @click="
                              downloadArchive(attachments.id, attachments.name)
                            "
                          >
                            <i class="fas fa-download"></i>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </b-form-group>
                </div>

                <div
                  v-if="details.webhook || details.webhook.length"
                  class="ml-2"
                >
                  <b-form-group label="WebHooks">
                    <div class="grid-webhook mb-2 ml-2">
                      <p class="to-label">ID</p>
                      <p class="to-label">Acao</p>
                      <p class="to-label">Callback</p>
                      <p class="to-label">URL</p>
                    </div>
                    <div
                      v-for="webhooks in details.webhook"
                      :key="webhooks.id"
                      class="mb-2 ml-2"
                    >
                      <div class="grid-webhook mb-2">
                        <p>{{ webhooks.id }}</p>
                        <p>{{ webhooks.trigger }}</p>
                        <p>{{ webhooks.callback }}</p>
                        <p>{{ parseJSON(webhooks.args).url }}</p>
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div v-if="details.club || details.club.length" class="ml-2">
                  <b-form-group label="Club">
                    <div
                      v-for="clubs in details.club"
                      :key="clubs.id"
                      class="mb-2 ml-2"
                    >
                      <p
                        v-for="course in clubs.course_classes"
                        :key="course.id"
                      >
                        <b-form-group label="">
                          <b-form-input
                            :value="course.name"
                            disabled
                          ></b-form-input>
                        </b-form-group>
                      </p>
                    </div>
                  </b-form-group>
                </div>

                <div v-if="details.gdigital" class="ml-2">
                  <b-form-group label="G Digital">
                    <div class="grid-mb mb-2 ml-2">
                      <p class="to-label">Conexão</p>
                      <p class="to-label">Callback</p>
                      <p class="to-label">Formulario</p>
                    </div>
                    <div v-for="gd in details.gdigital" :key="gd.id">
                      <div class="grid-mb mb-2 ml-2">
                        <p>{{ gd.connection_id }}</p>
                        <p>{{ gd.callback }}</p>
                        <p>{{ parseJSON(gd.args).id_form }}</p>
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div
                  v-if="details.memberkit || details.memberkit.length"
                  class="ml-2"
                >
                  <b-form-group label="MemberKit">
                    <div class="grid-mb mb-2 ml-2">
                      <p class="to-label">Conexão</p>
                      <p class="to-label">Acesso</p>
                      <p class="to-label">Membership Name</p>
                    </div>
                    <div
                      v-for="mb in details.memberkit"
                      :key="mb.id"
                      class="mb-2"
                    >
                      <div class="grid-mb mb-2 ml-2">
                        <p>{{ parseJSON(mb.data).connection_id }}</p>
                        <p>{{ parseJSON(mb.data).access }}</p>
                        <p>{{ parseJSON(mb.data).membership_name }}</p>
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div
                  v-if="
                    !details.club.length &&
                    !details.gdigital &&
                    !details.memberkit.length
                  "
                >
                  <p class="ml-2"> Sem Integrações </p>
                </div>
              </b-form-group>
            </span>
          </div>
        </b-tab>
        <b-tab title="Usuario">
          <div class="grid-tab">
            <span>
              <b-form-group label="ID do Cliente">
                <b-form-input
                  v-model="dataUser.seller.id"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Nome do Cliente">
                <b-form-input
                  v-model="dataUser.seller.name"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Telefone do Cliente">
                <b-form-input
                  v-model="dataUser.seller.cellphone"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="CPF/CNPJ do Cliente">
                <b-form-input
                  v-model="dataUser.seller.cpf_cnpj"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="E-mail do Cliente">
                <b-form-input
                  v-model="dataUser.seller.email"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Data de Cadastro do Cliente">
                <b-form-input
                  :value="formatDate(dataUser.seller.created_at)"
                  disabled
                ></b-form-input>
              </b-form-group>
            </span>
            <span>
              <b-form-group label="Documentos">
                <div
                  v-for="attachment in details.documents"
                  :key="attachment.id"
                  class="mb-2 ml-2"
                >
                  <b-form-group
                    :label="
                      attachment.status +
                      ' - ' +
                      formatDate(attachment.updated_at)
                    "
                  >
                    <div class="grid-archive">
                      <b-form-input
                        :value="attachment.path"
                        disabled
                      ></b-form-input>
                      <div
                        class="btnDownload"
                        @click="downloadDoc(attachment.path)"
                      >
                        <i class="fas fa-download"></i>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-form-group>
              <b-form-group label="Empresa">
                <div v-if="details.company" class="mb-2 ml-2">
                  <b-form-group label="Nome da Empresa">
                    <b-form-input
                      :value="details.company.name"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="CNPJ da Empresa">
                    <b-form-input
                      :value="details.company.cnpj"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="CNPJ da Empresa">
                    <b-form-input
                      :value="details.company.cnpj"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="E-mail da Empresa">
                    <b-form-input
                      :value="details.company.email"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Telefone da Empresa">
                    <b-form-input
                      :value="details.company.telephone"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="CEP da Empresa">
                    <b-form-input
                      :value="details.company.zip_code"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
                <p v-else class="ml-2">Não Cadastrou Empresa</p>
              </b-form-group>
            </span>
          </div>
        </b-tab>
        <b-tab title="Solicitações de reembolso">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive mb-0">
                <b-table
                  :items="refundeds"
                  :fields="fieldsHistory"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>
                  <template v-slot:cell(updated_at)="data">
                    {{ data.value | datetime }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Produtos Aprovados">
          <div class="row">
            <div class="col-12">
              <p
                >Ja foram aprovados {{ details.total_products }} produtos desse
                cliente.</p
              >
              <div class="table-responsive mb-0">
                <b-table
                  :items="products"
                  :fields="fieldsProducts"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  :filter-included-fields="filterOn"
                >
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>

                  <template v-slot:cell(available_date)="data">
                    {{ data.value | date }}
                  </template>

                  <template v-slot:cell(type)="data">
                    {{
                      data.value == 'TRANSACTION' ? 'Valor único' : 'Assinatura'
                    }}
                  </template>

                  <template v-slot:cell(amount)="data">
                    R$ {{ formatMoney(data.value) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Vendas no Greenn">
          <div class="row">
            <div class="col-12">
              <p
                >Ultimas {{ movements.length }} Vendas de
                {{ details.total_sales }}</p
              >
              <div class="table-responsive mb-0">
                <b-table
                  :items="movements"
                  :fields="fields"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <template v-slot:cell(transaction_id)="data">
                    <a :title="data.value">
                      {{
                        data.value.length >= 10
                          ? data.value.substr(0, 10) + '...'
                          : data.value
                      }}
                    </a>
                  </template>

                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>

                  <template v-slot:cell(type)="data">
                    {{
                      data.value == 'TRANSACTION' ? 'Valor único' : 'Assinatura'
                    }}
                  </template>

                  <template v-slot:cell(status)="data">
                    <b-badge v-if="data.value == 'unpaid'" variant="secondary"
                      >Não pago</b-badge
                    >
                    <b-badge v-if="data.value == 'paid'" variant="success"
                      >Pago</b-badge
                    >
                    <b-badge
                      v-if="
                        data.value == 'processing' ||
                        data.value == 'waiting_payment'
                      "
                      variant="secondary"
                      >Processando</b-badge
                    >
                    <b-badge
                      v-if="data.value == 'refused' || data.value == 'reject'"
                      variant="danger"
                      >Recusada</b-badge
                    >
                    <b-badge v-if="data.value == 'refunded'" variant="warning"
                      >Reembolsado</b-badge
                    >
                    <b-badge v-if="data.value == 'chargedback'" variant="dark"
                      >Charged Back</b-badge
                    >
                    <b-badge v-if="data.value == 'trialing'" variant="info"
                      >Avaliação</b-badge
                    >
                  </template>

                  <template v-slot:cell(total)="data">
                    R$
                    {{
                      formatMoney(data.item.status == 'paid' ? data.value : 0)
                    }}
                  </template>

                  <template v-slot:cell(balance)="data">
                    R$ {{ formatMoney(data.value ? data.value : 0) }}
                  </template>

                  <template v-slot:cell(antecipation_fee)="data">
                    <div v-if="data.value && data.value > 0">
                      R$ {{ formatMoney(data.value) }}
                      <b-badge v-if="!data.item.antecipated" variant="info"
                        >Prévia</b-badge
                      >
                    </div>
                  </template>

                  <template v-slot:cell(method)="data">
                    <PaymentMethodIcon :method="data.value" />
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Saques">
          <div class="row">
            <div class="col-12">
              <p> Total de R$ {{ formatMoney(details.total_withdrawals) }}</p>
              <div class="table-responsive mb-0">
                <b-table
                  :items="withdrawals"
                  :fields="fieldsWithdrawals"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>

                  <template v-slot:cell(amount)="data">
                    R$ {{ formatMoney(data.value) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Reembolsos">
          <div class="row">
            <div class="col-12">
              <p
                >{{ parseInt(details.percentage_refund_solicitations, 10) }}% de
                Reembolso com base no Vendedor</p
              >
              <div class="table-responsive mb-0">
                <b-table
                  :items="refundeds"
                  :fields="fieldsRefund"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Chargedbacks">
          <div class="row">
            <div class="col-12">
              <p
                >{{ parseInt(details.percentage_chargedback, 10) }}% de
                Chargedback com base no Vendedor</p
              >
              <div class="table-responsive mb-0">
                <b-table
                  :items="chargedbacks"
                  :fields="fieldsChargedbacks"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >
                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Avaliações">
          <div class="row">
            <div class="col-6">
              <b-form-group
                v-if="details.product_rating"
                label="Avaliação do Produto"
              >
                <b-form-input
                  v-model="details.product_rating"
                  disabled
                ></b-form-input>
              </b-form-group>
              <div v-else>
                <p>Produto sem Avaliação</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              v-if="details.product_obs && details.product_obs.length"
              class="col-12"
            >
              <b-form-group
                v-for="comment in details.product_obs"
                :key="comment.id"
                label="Comentario no Produto"
              >
                <b-form-textarea
                  v-model="comment.avaliation_value"
                  disabled
                ></b-form-textarea>
              </b-form-group>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div v-if="!loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import CategoryService from '@services/resources/CategoryService'
import DetailService from '@services/resources/DetailService'
import DownloadService from '@services/resources/DownloadService'
import moment from 'moment'
import Money from '@src/mixins/money'
import {AccessLevel} from '@views/configurations/enums/accessLevel'
const serviceCategory = CategoryService.build()
const serviceDetails = DetailService.build()
const serviceDownload = DownloadService.build()

export default {
  mixins: [Money],
  props: ['dadosUser', 'type', 'lineTable'],
  data() {
    return {
      loading: false,
      categories: [],
      details: [],
      movements: [],
      refundeds: [],
      products: [],
      withdrawals: [],
      chargedbacks: [],
      filter: '',
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'transaction_id', label: 'ID Pagarme', sortable: true },
        { key: 'id', label: 'ID Greenn', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'type', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'balance', label: 'Valor distribuído', sortable: true },
        { key: 'method', label: 'Método', sortable: false },
        { key: 'antecipation_fee', label: 'Antecipação', sortable: false },
      ],
      fieldsRefund: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'category', label: 'Categoria', sortable: true },
        { key: 'motive', label: 'Motivo', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
      fieldsHistory: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: 'updated_at', label: 'Data de Atualização', sortable: true },
      ],
      fieldsProducts: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'name', label: 'Produto', sortable: false },
        { key: 'type', label: 'Tipo', sortable: false },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: 'amount', label: 'Valor', sortable: true },
      ],
      fieldsWithdrawals: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: 'amount', label: 'Valor', sortable: true },
      ],
      fieldsChargedbacks: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'transaction_id', label: 'Transação ID', sortable: true },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
    }
  },
  computed: {
    canDownloadAttachment() {
      if (this.useActionPermissions) {
        return this.$canAction('products_download_attachment', AccessLevel.EDITOR)
      }
      return true;
    }
  },
  methods: {
    formatProduct(e) {
      if (e === 'INFOPRODUCT') {
        return 'INFOPRODUTO'
      } else if (e === 'SERVICE') {
        return 'SERVICO'
      } else if (e === 'PHYSICALPRODUCT') {
        return 'PRODUTO FÍSICO'
      } else if (e === 'EVENT') {
        return 'EVENTO'
      } else if (e === 'OTHERS') {
        return 'OUTROS'
      }
      return e
    },
    parseJSON(e) {
      return JSON.parse(e)
    },
    accept(e, i) {
      this.$emit('accept', [e, i])
    },
    deny(e, i) {
      this.$emit('deny', [e, i])
    },
    formatDate(e) {
      return moment(e).format('DD/MM/YYYY HH:mm')
    },
    typeFilter(e) {
      if (e === 'SUBSCRIPTION') {
        return 'ASSINATURA'
      } else if (e === 'TRANSACTION') {
        return 'TRANSAÇÃO'
      }
      return e
    },
    downloadDoc(path) {
      const ext = path.split('.').pop()
      let data = {
        url: path,
      }

      serviceDownload
        .blob(data)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `arquivo.${ext}`)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    downloadArchive(id, path) {
      axios({
        url: process.env.VUE_APP_API_HOST + `/api/attachment/download/${id}`,
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: Cookies.get('access_token'),
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', path)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    reset() {},
    fetchDetails() {
      serviceDetails
        .read({ id: this.dataUser.id })
        .then((response) => {
          this.details = response
          this.movements = response.sales
          this.refundeds = response.refund_solicitations
          this.products = response.products
          this.withdrawals = response.withdrawals
          this.chargedbacks = response.chargedback
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.submit = false
        })
    },
    fetchCategories() {
      serviceCategory
        .search()
        .then((response) => {
          response.forEach((element) => {
            this.categories.push({ value: element.id, text: element.name })
          })
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.submit = false
        })
    },
    openModal() {
      this.loading = true
      this.reset()
      this.dataUser = this.dadosUser
      this.fetchDetails()
      this.fetchCategories()
    },
  },
}
</script>

<style lang="scss">
.grid-web {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}

.grid-webhook {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 3fr;
  gap: 10px;
}

.grid-mb {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr;
  gap: 10px;
}

.carousel-inner {
  border-radius: 3px !important;
}

.grid-tab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}

.carousel-control-prev,
.carousel-control-next {
  filter: invert(1);
}

textarea {
  resize: none;
}

.btnDownload {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(210, 210, 210);
  border-radius: 3px;
  cursor: pointer;
}

.actions-modal {
  margin-top: -17px;
  margin-bottom: -12px;
  gap: 10px;
  display: flex;
  justify-content: flex-end;
}

.image-size {
  img {
    height: 25vh;
    object-fit: contain;
  }
}

.to-label {
  font-weight: 600;
}

.grid-archive {
  display: grid;
  grid-template-columns: 5fr 1fr;
  gap: 10px;
  button {
    border: none;
  }
}
</style>